import { render, staticRenderFns } from "./login-page.vue?vue&type=template&id=bebc48c0&scoped=true&lang=pug&"
import script from "./login-page.vue?vue&type=script&lang=ts&"
export * from "./login-page.vue?vue&type=script&lang=ts&"
import style0 from "./login-page.vue?vue&type=style&index=0&id=bebc48c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebc48c0",
  null
  
)

export default component.exports